import { Filter, FilterConfig, FilterTypes, IsFilterable } from "@/lib/filterable";
import { MrfiktivPartnerDatevAccountViewModelGen } from "@/services/mrfiktiv/v1/data-contracts";
import { ITimestamp, Timestamp } from "./timestamp.entity";

export type DatevAccountType = MrfiktivPartnerDatevAccountViewModelGen["type"];

/**
 * A partner's DATEV account (Sachkonto), identified by its account `number`
 * rather than a human-chosen name. Read-only on the frontend: accounts are
 * created via `Company`/`Person` (`makeCreditor`/`makeDebtor`) or the DATEV
 * import, never directly.
 */
@IsFilterable
class DatevAccountBase implements Omit<MrfiktivPartnerDatevAccountViewModelGen, "ref"> {
  @FilterConfig({
    type: FilterTypes.OBJECT_ID,
    displayName: "objects.datevAccount.id"
  })
  id: string;

  partnerId: string;

  @FilterConfig({
    type: FilterTypes.STRING,
    displayName: "objects.datevAccount.type"
  })
  type: DatevAccountType;

  @FilterConfig({
    type: FilterTypes.NUMBER,
    displayName: "objects.datevAccount.number"
  })
  number: number;

  @FilterConfig({
    type: Timestamp
  })
  timestamp: ITimestamp;

  constructor(account?: Partial<MrfiktivPartnerDatevAccountViewModelGen>) {
    this.id = account?.id ?? "";
    this.partnerId = account?.partnerId ?? "";
    this.type = account?.type ?? "creditor";
    this.number = account?.number ?? 0;
    this.timestamp = new Timestamp(account?.timestamp);
  }

  get titleReadable(): string {
    return `${this.number}`;
  }
}

type IDatevAccount = DatevAccountBase;
const DatevAccount = Filter.createForClass(DatevAccountBase);

export { DatevAccount, IDatevAccount };
